import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

import rocks from "../../../assets/data/rocks.json";

export default {
  namespaced: true,
  state() {
    return {
      rockDatabase: rocks.rocks,
      currentTitle: "",
      noMatch: false,
      oneRock: {},
      querySuggestions: [],
      results: [],
      rockNames: [],
      title: {
        //Titles current possible in english and portuguese
        en: "rocks",
        pt: "rochas",
      },
    };
  },
  actions,
  getters,
  mutations,
};
